'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const dayMap = {
  MONDAY: 'Mon',
  TUESDAY: 'Tue',
  WEDNESDAY: 'Wed',
  THURSDAY: 'Thur',
  FRIDAY: 'Fri',
  SATURDAY: 'Sat',
  SUNDAY: 'Sun'
};

// Convert to 12 hour clock
// 0900 => 9am; 1830 => 6:30pm
const amPmTime = time => {
  const hours = +time.substring(0, 2);
  const minutesString = time.substring(2, 4);
  if (minutesString === '00') {
    return hours >= 12 ? `${hours === 12 ? hours : hours - 12}pm` : `${hours}am`;
  }
  return [hours > 12 ? `${hours - 12}` : hours, hours >= 12 ? `:${minutesString}pm` : `:${minutesString}am`].join('');
};

// Check if we match 24 hour clock with dash separator
// 0900-1800 = true; Closed = false;
const timeConversion = hours => hours.match(/\d{4}-\d{4}/) ? hours.split('-').map(amPmTime).join('-') : hours;

// Returns the boundaries of a group of days with shortened day mapping & hour conversion
// {0900-1800: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY']} => Mon-Thurs 9am-6pm
const compressDayGroups = _ref => {
  let [timeSpan, days] = _ref;
  const hours = timeConversion(timeSpan);
  if (days.length > 2) {
    return `${dayMap[days[0]]} - ${dayMap[days[days.length - 1]]} ${hours}`;
  }
  if (days.length === 2) {
    return `${dayMap[days[0]]} & ${dayMap[days[days.length - 1]]} ${hours}`;
  }
  if (days.length === 1) {
    return `${dayMap[days[0]]} ${hours}`;
  }
  return undefined;
};

// Group by matching time then days that match that time
// {0900-1800: ['MONDAY', 'TUESDAY', 'WEDNESDAY'], CLOSED: ['SATURDAY']}
const hoursGrouping = hours => hours.reduce((timeGroup, openingHours) => ({
  ...timeGroup,
  [openingHours.hours]: Object.hasOwn(timeGroup, openingHours.hours) ? [...timeGroup[openingHours.hours], openingHours.day] : [openingHours.day]
}), {});

// Runs all above on the OpeningHours[] type and joins into final string with ; seperator
const openingConversion = hours => Object.entries(hoursGrouping(hours)).map(compressDayGroups).join('; ');

exports["default"] = openingConversion;
